import * as React from "react";
import {
  getFormattedDate,
  getTime
} from "./Script";

interface DateProps {
  /**
   * Any special class name
   */
  className?: string;
  /**
   * Data test id
   */
  dataTestId?: string;
  /**
   * Format
   */
  format?: "dateOnly";
  /**
   * The formatted date value
   */
  value: string;
}

/**
 * Presentation layer of Date component
 *
 * @param props The props passed to the component
 * @returns the DateView
 */
export const CustomDate: React.FC<DateProps> = (props: DateProps): JSX.Element => {
  const { className, dataTestId, format, value } = props;
  const formattedValue = format === "dateOnly" ?
    getFormattedDate(value, true) :
    getFormattedDate(value, true) + " " + getTime(value);

  return (
    <span className={className} data-testid={dataTestId}>
      {formattedValue}
    </span>
  );
};
